import React, { Component, Fragment } from 'react';
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import { User, Unlock } from 'react-feather';
import { withRouter } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class LoginTabset extends Component {

    documentData;
    constructor(props) {
        super(props);
        this.state = {
            activeShow: true,
            startDate: new Date(),
            email: '',
            password: ''
        }
        this.handleChange = this.handleChange.bind(this)
        this.submitHandler = this.submitHandler.bind(this)
    }

    clickActive = (event) => {
        document.querySelector(".nav-link").classList.remove('show');
        event.target.classList.add('show');
    }
    handleChange(date) {
        this.setState({
            startDate: date
        });
    }

    routeChange = () => {
        // this.props.history.push(`${process.env.PUBLIC_URL}/dashboard`);
        window.location.href = "/dashboard"
    }

    submitHandler(e) {
        e.preventDefault();
        const url = `${process.env['REACT_APP_HOST']}/api/users/login/`;
        const params = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: e.target.email.value,
                password: e.target.password.value,
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                if (data.msg == 'success' && data.isAdmin == true) {
                    localStorage.setItem('userInfo', JSON.stringify(data));
                    // this.props.history.push(`${process.env.PUBLIC_URL}/dashboard`);
                    window.location.href = "/admin/dashboard"

                    window.location.href = process.env.PUBLIC_URL + '/dashboard';
                    console.log(window.location.href)
                } else { toast.error("Invalid email or password") }

            })
    }

    render() {
        return (
            <div>
                <Fragment>
                    <Tabs>
                        <TabList className="nav nav-tabs tab-coupon" >
                            <Tab className="nav-link" onClick={(e) => this.clickActive(e)}><User />Login</Tab>
                        </TabList>
                        <ToastContainer />
                        <TabPanel>
                            <form className="form-horizontal auth-form " method="post" action="" onSubmit={this.submitHandler}>
                                <div className="form-group">
                                    <input required="" name="email" type="email" onChange={(e) => this.setState({ email: e.target.value })} className="form-control" placeholder="Username" />
                                </div>
                                <div className="form-group">
                                    <input required="" name="password" type="password" onChange={(e) => this.setState({ password: e.target.value })} className="form-control" placeholder="Password" />
                                </div>
                                <div className="form-terms">
                                    <div className="custom-control custom-checkbox mr-sm-2">
                                        <input type="checkbox" className="custom-control-input" id="customControlAutosizing" />

                                    </div>
                                </div>
                                <div className="form-button">
                                    <input type="submit" className="btn btn-primary" name="submit" value="Login" />
                                </div>

                            </form>
                        </TabPanel>
                    </Tabs>
                </Fragment>
            </div>
        )
    }
}

export default withRouter(LoginTabset)

